import { Injectable } from '@angular/core';
import { BaseStore } from '@macs-frontend/core/store/base.store';
import { makeObservable } from '@macs-frontend/core/utils/mobx';
import { action, observable } from 'mobx-angular';

export enum SaveButtonStatus {
  DEFAULT = 'DEFAULT',
  SAVING = 'SAVING',
  SAVED = 'SAVED',
}

/* Use in case we need few buttons on the same screen */
export enum SaveButtonId {
  DEFAULT = 'DEFAULT',
}

@Injectable({
  providedIn: 'root',
})
export class SaveButtonStore extends BaseStore {
  @observable
  buttonsStatuses: { [key in SaveButtonId]?: SaveButtonStatus } = {};

  savedTimeouts: { [key in SaveButtonId]?: number } = {};

  constructor() {
    super();
    makeObservable(this);
  }

  @action
  switchToDefault(id: SaveButtonId = SaveButtonId.DEFAULT) {
    this.buttonsStatuses[id] = SaveButtonStatus.DEFAULT;
  }

  @action
  switchToSaving(id: SaveButtonId = SaveButtonId.DEFAULT) {
    this.buttonsStatuses[id] = SaveButtonStatus.SAVING;
  }

  @action
  switchToSaved(id: SaveButtonId = SaveButtonId.DEFAULT) {
    this.buttonsStatuses[id] = SaveButtonStatus.SAVED;
    this.savedTimeouts[id] = setTimeout(() => {
      if (this.savedTimeouts[id]) {
        clearTimeout(this.savedTimeouts[id]);
        this.buttonsStatuses[id] = SaveButtonStatus.DEFAULT;
      }
    }, 4000) as unknown as number;
  }
}
